import React, {useState, useEffect} from 'react'

const ListaDesplegable = ({
  onChange,
  onBlur,
  estilosContenedor,
  estilosLista,
  titulo,
  opciones,
  valor,
  nombre,
  deshabilitado = false,
  tabIndex = 0,
  colorTextoOpciones = 'text-cendiatra-gris-3',
  nombrePropiedadPorDefecto = 'Elegir',
}) => {
  const valorSeleccionado = opciones.find((val) => {
    return val.Id === valor
  })

  const [cambiarColorInput, setCambiarColorInput] = useState(false)

  const validarSeleccion = (valor) => {
    return setCambiarColorInput(Boolean(valor))
  }

  useEffect(() => {
    validarSeleccion(valor)
  }, [valor])

  return (
    <div
      className={`${estilosContenedor} flex justify-start items-center flex-wrap`}
    >
      <label className="block text-13px font-medium text-cendiatra my-5px w-full">
        {titulo}
      </label>
      <select
        className={` ${estilosLista} ${
          cambiarColorInput
            ? `${colorTextoOpciones}`
            : 'text-cendiatra-gris-placeholder'
        }`}
        onChange={onChange}
        value={valorSeleccionado?.Id ?? valor}
        onBlur={onBlur ? onBlur : () => {}}
        name={nombre}
        disabled={deshabilitado}
        tabIndex={tabIndex}
      >
        <option key="-1" value="">
          {nombrePropiedadPorDefecto}
        </option>
        {opciones.map((item) => (
          <option
            key={item.Id}
            value={item.Id}
            className={item.Color ? item.Color : 'text-cendiatra-gris-3'}
          >
            {item.Nombre}
          </option>
        ))}
      </select>
    </div>
  )
}

export default ListaDesplegable
